<template>
  <div class="crypto-cards bg--color-01">
    <div class="container-wrapper bg--color-11">
      <div class="crypto-cards__container container-new">
        <h2 class="crypto-cards__title txt--color-05 txt--26px txt--52px--l txt--weight-700 txt--height-34px txt--height-64px--l mb-24 mb-42--l">
          {{ $t('cryptoCards.cryptoCardsSection.title') }}
        </h2>
        <div class="crypto-cards__items">
          <div v-for="(item, i) in items" :key="i" class="crypto-cards__item flx flx--items-center bor--radius-20 bg--color-01 p-20" :class="item.class || ''">
            <component :is="`icon${i}`" />
            <p class="txt--color-05 txt--16px txt--22px--l txt--weight-500 txt--height-20px txt--height-30px--l mb-0">
              {{ item.title }}
            </p>
          </div>
        </div>
      </div>-
    </div>
  </div>
</template>

<script>
export default {
  name: 'CryptoCards',
  components: {
    icon0: () => import('@/assets/icons/crypto-cards/crypto-cards/0.svg?inline'),
    icon1: () => import('@/assets/icons/crypto-cards/crypto-cards/1.svg?inline'),
    icon2: () => import('@/assets/icons/crypto-cards/crypto-cards/2.svg?inline'),
    icon3: () => import('@/assets/icons/crypto-cards/crypto-cards/3.svg?inline'),
    icon4: () => import('@/assets/icons/crypto-cards/crypto-cards/4.svg?inline'),
    icon5: () => import('@/assets/icons/crypto-cards/crypto-cards/5.svg?inline'),
  },
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(760)
    },
    items () {
      return [
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.0'),
        },
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.1'),
        },
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.2'),
          class: 'star-top-right',
        },
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.3'),
          class: 'star-bottom-right',
        },
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.4'),
        },
        {
          title: this.$t('cryptoCards.cryptoCardsSection.list.5'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.crypto-cards {

  &__title {
    text-align: center;

    @include bp(l) {
      width: max-content;
      position: relative;

      &::before {
        content: url('@/assets/icons/crypto-cards/star.svg');
        display: block;
        position: absolute;
        right: toRem(-36px);
        top: toRem(-36px);
      }
    }
  }

  &__items {
    display: grid;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);
      gap: toRem(20px);
    }

    @include bp(l) {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 1fr);
    }
  }

  &__item {
    gap: toRem(20px);

    @include bp(m) {
      flex-direction: column;
      gap: toRem(24px);
      align-items: flex-start;
    }
  }

  .star-top-right {
    position: relative;

    @include bp(l) {
      &::before {
        content: url('@/assets/icons/crypto-cards/star.svg');
        display: block;
        position: absolute;
        right: toRem(4px);
        top: toRem(-20px);
      }
    }
  }

  .star-bottom-right {
    position: relative;

    @include bp(l) {
      &::before {
        content: url('@/assets/icons/crypto-cards/star.svg');
        display: block;
        position: absolute;
        right: 0;
        bottom: toRem(-16px);
      }
    }
  }
}
</style>
